/*----- Core -----*/
import React, { useState } from 'react'
import styled, { css } 		 from 'styled-components'
import { connect }         from "react-redux"
import { NavLink }         from 'react-router-dom'

/*----- Components -----*/
import NavButton from '../../button/NavButton'

/*----- Ant -----*/
import { Menu, Dropdown } from 'antd'

/*----- Assets -----*/
import Logo         from '../../../assets/logo.svg'
import GearIcon     from '../../../assets/icons/gear.svg'
import CloseIcon    from '../../../assets/icons/close_white.svg'
import OpenMenuIcon from '../../../assets/icons/open_menu.svg'

/*----- Commons -----*/
import Device     from '../../../commons/Device'
import Color      from '../../../commons/Color'
import Montserrat from '../../../commons/mixins/fonts/Montserrat'

/*----- Actions -----*/
import { logout } from '../../../modules/login/Actions'

/*----- Styles -----*/
const StyledHeader = styled.header`
	background-color: white;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 16px;
	position: fixed;
	width: 100%;
	top: 0;
	left: 0;
	z-index: 4;
	background-color: white;
	.app-header__logo-container {
		display: flex;
    justify-content: center;
    align-items: center;
		height: 68px;
    border-radius: 8px;
		padding: 0 0 4px 8px;
		margin: 0;
		img {
			width: 160px;
			padding: 10px;
		}
	}
	.app-header__nav-button-container {
		display: none;
		align-items: center;
		border-radius: 8px;
		height: 68px;
		width: 100%;
		padding-left: 8px;
		a {
			height: 100%;
		}
	}
	.call-to-action {
		height: 36px;
		display: flex;
		button {
			border: none;
			cursor: pointer;
			outline: none;
			background: none;
			img {
				width: 20px;
			}
		}
	}
	.admin-avatar__container {
		height: 40px;
		width: 40px;
		border-radius: 50%;
		background-color: ${ Color.main };
		display: flex;
    justify-content: center;
    align-items: center;
		margin-right: 64px;
		img {
			width: 20px;
		}
	}
	.nav-button {
		&:last-child {
			font-weight: 600;
			text-transform: uppercase;
			color: white;
			background: ${ Color.main };
			border-radius: 30px;
			height: 36px;
			&:hover {
				box-shadow: none;
			}
		}
	}
	.app-header__menu-button {
		position: absolute;
    top: 10px;
    right: 32px;
		border: none;
		height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: none;
		cursor: pointer;
		&:focus {
			border: none;
    	outline: none;
		}
		img {
			width: 16px;
		}
	}
	.open-menu {
		display: block;
		img {
			width: 20px;
			margin-top: 8px;
		}
	}
	@media ${ Device.md } {
		padding: 0 32px;
		.app-header__nav-button-container {
			display: flex;
			padding: 0 32px;
			height: 68px;
			width: auto;
		}
		.open-menu {
			display: none;
		}
	}
	
`

const StyledFloatedMenu = styled.aside`
	position: absolute;
	top: 0;
	right: -500px;
	height: 100vh;
	max-width: 250px;
	width: 100%;
	background-color: ${Color.main};
	display: flex;
	flex-direction: column;
	padding: 32px;
	transition: all 0.5s;
	z-index: 1;
	.floated-menu__button-container {
		margin-top: 64px;
		display: flex;
    flex-direction: column;
	}
	.floated-menu__button {
		${ Montserrat(24, 600, 'white') };
		text-transform: capitalize;
		margin: 12px 0;
	}
	${props => props.menuIsOpen && css`
		box-shadow: 0px 0px 128px 100px rgba(0,0,0,0.1);
		right: 0;
  `}
`

const FloatedMenu = ({ menuIsOpen, setMenuIsOpen }) => {
	return (
		<StyledFloatedMenu className="floated-menu" menuIsOpen={menuIsOpen}>
			<button className="app-header__menu-button" onClick={() => setMenuIsOpen(false)}>
				<img src={CloseIcon} alt="Menu icon"/>
			</button>
			<div className="floated-menu__button-container" >
				<NavLink to="/" className="floated-menu__button" onClick={() => setMenuIsOpen(false)}>
					Home
				</NavLink>
				<NavLink to="/producers" className="floated-menu__button" onClick={() => setMenuIsOpen(false)}>
					Productores
				</NavLink>
				<NavLink to="/our-home" className="floated-menu__button" onClick={() => setMenuIsOpen(false)}>
					Nuestra casa
				</NavLink>
				<NavLink to="/contact" className="floated-menu__button" onClick={() => setMenuIsOpen(false)}>
					Sumate
				</NavLink>
			</div>
		</StyledFloatedMenu>
	)
}

/*----- Component -----*/
const Header = ({ location, logout }) => {

	const [ menuIsOpen, setMenuIsOpen ] = useState(false)

	const userIsLoggedIn = localStorage.getItem('userIsLoggedIn')

	const checkSelected = (url) => {
		return location.pathname === url
	}

	const menu = (
		<Menu>
			<Menu.Item>
				<NavLink to="/admin/producers/create">Panel de administración</NavLink>
			</Menu.Item>
			<Menu.Divider />
			<Menu.Item onClick={logout}>
				Cerrar sesión
			</Menu.Item>
		</Menu>
	)

	return(
		<StyledHeader className="app-header">
			<FloatedMenu menuIsOpen={menuIsOpen} setMenuIsOpen={setMenuIsOpen} />
			<div className="app-header__logo-container">
				<NavLink to="/">
					<img src={Logo} alt="logo" />
				</NavLink>
			</div>
			<div className="app-header__nav-button-container">
				<NavButton 
					content    	= "Home"
					selected		= { checkSelected("/") }
					destination = "/" 
				/>
				<NavButton 
					content    	= "Productores"
					selected		= { checkSelected("/producers") }
					destination = "/producers" 
				/>
				<NavButton 
					content    	= "Nuestra casa"
					selected		= { checkSelected("/our-home") }
					destination = "/our-home" 
				/>
				<NavButton 
					content    	= "Sumate"
					selected		= { checkSelected("/contact") }
					destination = "/contact"
				/>
			</div>
			<button className="app-header__menu-button open-menu" onClick={ () => setMenuIsOpen(true) }>
				<img src={OpenMenuIcon} alt="Menu icon"/>
			</button>
			{
				userIsLoggedIn? 
				(
					<Dropdown overlay={menu} trigger={['click']}>
						<div className="admin-avatar">
							<div className="admin-avatar__container">
								<img src={GearIcon} alt="gear icon" />
							</div>
						</div>
					</Dropdown>
				) : null
			}
		</StyledHeader>
	)
}

function mapStateToProps(state) {
	return {
		location: state.router.location
	}
}

function mapDispatchToProps(dispatch) {
	return {
		logout: () => logout(dispatch)
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Header)
